// src/stores/ast/ast.store.ts
import { createStore } from '@stencil/store';
import { ConfigAST } from './ast.types';

const initialState: ConfigAST = new ConfigAST();

const { state,get, set, onChange } = createStore(initialState);

export const astStore = {
  state,
  get,
  set,
  onChange,
  updateComponent: (data: ComponentItem) => {
      const componentsList = state.components;
      const prop = data.prop;
      const index = componentsList.findIndex(type => type.prop === prop);
      state.components[index] = data;
      state.components = [...state.components];
  },
  updateProp: (key,val)=>{
    set(key, val);
  },
};